import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ComingSoon from './pages/ComingSoon';
import VendorRegister from './pages/VendorRegister';
import Home from './pages/Home';
import VendorLogin from './pages/VendorLogin';
import VendorDashboard from './pages/VendorDashboard';
import VendorProfile from './pages/VendorProfile';
import Pricing from './pages/Pricing';
import Checkout from './pages/Checkout';
import AdminDashboard from './pages/AdminDashboard';
import AdminUserDashboard from './pages/AdminUserDashboard';
import AdminVendorStats from './pages/AdminVendorStats';
import AdminVendorReview from './pages/AdminVendorReview';
import CopyrightReportDetail from './pages/CopyrightReportDetail';
import ReportCopyright from './pages/ReportCopyright';
import AdminUnlinkedReports from './pages/AdminUnlinkedReports';
import AdminMarketingDashboard from './pages/AdminMarketingDashboard';
import VendorMessages from './pages/VendorMessages';
import './App.css';

const SHOW_COMING_SOON = process.env.REACT_APP_SHOW_COMING_SOON === 'true';

function App() {
  if (SHOW_COMING_SOON) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<ComingSoon />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/vendor/login" element={<VendorLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/users" element={<AdminUserDashboard />} />
        <Route path="/admin/vendor-stats" element={<AdminVendorStats />} />
        <Route path="/admin/vendor/:id" element={<AdminVendorReview />} />
        <Route path="/admin/copyright-report/:id" element={<CopyrightReportDetail />} />
        <Route path="/report-copyright" element={<ReportCopyright />} />
        <Route path="/admin/unlinked-reports" element={<AdminUnlinkedReports />} />
        <Route path="/admin/marketing" element={<AdminMarketingDashboard />} />
        <Route path="/vendor/register" element={<VendorRegister />} />
        <Route path="/vendor/dashboard" element={<VendorDashboard />} />
        <Route path="/vendor/profile" element={<VendorProfile />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/vendor/messages" element={<VendorMessages />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;